import * as types from "./actionTypes";

export const showModal = images => {
    return {
        type: types.SHOW_UPLOAD_IMAGE_MODAL,
        images
    };
};

export const hideModal = () => {
    return {
        type: types.HIDE_UPLOAD_IMAGE_MODAL
    };
};

export const uploadImageRequest = (images) => {
    return {
        type: types.UPLOAD_IMAGE_REQUEST,
        images
    };
};

export const uploadImageSuccess = uploadedImageIndex => {
    return {
        type: types.UPLOAD_IMAGE_SUCCESS,
        uploadedImageIndex
    };
};

export const uploadImageFailure = uploadedImageIndex => {
    return {
        type: types.UPLOAD_IMAGE_FAILURE,
        uploadedImageIndex
    };
};